import serializeForm from '../utils/consultation/serialize-form';
import { postToLeadWithCaptcha } from '../utils/post-to-lead-with-captcha';
import { initCaptchaForForm } from '../utils/captcha-v2';
import { validate } from '../utils/validation';
import { paperPlaneAnimation, paperPlaneAnimationDone } from './button-paper-plane';
import attachTrackingPayload from '../utils/tracking-payload';
import { getEmailLeadDimenions } from '../utils/ga4-tracking/custom-dimensions';
import { pushToDataLayer } from '../utils/ga4-tracking/push-to-data-layer';
import { pageSettings } from '../utils/ga4-tracking/page-settings';
import { slideDown, slideUp } from '../startup/slide';
import { NotificationContainerHandler } from '../forms/form-library';

document.querySelectorAll('.ebook-block').forEach(ebookBlock => {
  if (ebookBlock) {
    const ebookTabsContainer = ebookBlock.querySelector('.tabs');
    const ebookTabs = ebookTabsContainer.querySelectorAll('.tab');

    if (ebookTabsContainer && ebookTabs) {
      ebookBlock.querySelectorAll('.tab-radios input').forEach(input => {
        input.addEventListener('change', () => {
          ebookTabs.forEach(tab => {
            tab.classList.toggle('active');
          });
        });
      });

      const maxTabHeight = Math.max(...Array.from(ebookTabs).map(tab => tab.offsetHeight));
      ebookTabsContainer.style.height = maxTabHeight + 'px';
    }

    ebookBlock.querySelectorAll('select[name="lang"]').forEach(elem => {
      const ebookBlock = elem.closest('.ebook-block');
      elem.addEventListener('change', e => {
        const id = elem.value;
        const activeTab = ebookBlock.querySelector('.tabs .tab.active');
        const choosenTab = ebookBlock.querySelector('.tabs #' + id);
        choosenTab.querySelector('select[name="lang"]').value = id;
        activeTab.classList.remove('active');
        setTimeout(() => {
          activeTab.style = 'display: none';
          choosenTab.style = 'display: block';
        }, 150);
        setTimeout(() => {
          choosenTab.classList.add('active');
        }, 160);
      });
    });

    ebookBlock.querySelectorAll('.tab').forEach(block => {
      const formEbook = block.querySelector('form[data-type]');
      const button = formEbook.querySelector('.submitter');
      const captchaMountElement = formEbook.querySelector('.captaincaps');
      let captchaController;
      const inputs = formEbook.querySelectorAll('.form-field');
      const type = formEbook.getAttribute('data-type');
      const notificationHandler = new NotificationContainerHandler(block);

      const emailInput = formEbook.querySelector('input[name="email"]');

      const { controller, requireCaptchaOnSubmit } = initCaptchaForForm({
        form: formEbook,
        mountElement: captchaMountElement,
        emailInput,
        locale: en ? 'en' : 'de',
        onShowWidget: () => {
          captchaMountElement?.classList.remove('is-hidden');
          button.classList.add('is-hidden');
        },
        onHideWidget: () => {
          captchaMountElement?.classList.add('is-hidden');
          button.classList.remove('is-hidden');
        }
      });
      captchaController = controller;

      formEbook.addEventListener(
        'input',
        () => {
          if (captchaController && !captchaController.hasUsableToken()) {
            captchaController.startIfNeeded();
          }
        },
        { once: true }
      );

      let emailInvalid = false;

      const ebookLangCheck = ['expats-en', 'welcome-guide-en', 'students-en', 'after-study-guide-en'].some(cls => formEbook.dataset.type === cls);
      const prepareText = ebookLangCheck
        ? `<span>Preparing <span class="loading-dot">.</span><span class="loading-dot">.</span><span class="loading-dot">.</span></span>`
        : `<span>Vorbereitung läuft <span class="loading-dot">.</span><span class="loading-dot">.</span><span class="loading-dot">.</span></span>`;

      emailInput?.addEventListener('input', () => {
        if (emailInvalid) {
          button.style.removeProperty('--plane-color');
          button.disabled = false;
          emailInvalid = false;
          slideUp(alerts.email);
        }
      });

      const alerts = {
        default: formEbook.querySelector('.alert.default'),
        email: formEbook.querySelector('.alert.email')
      };

      button.addEventListener('click', async e => {
        e.preventDefault();
        if (document.referrer.includes('secprf.com')) {
          pushToDataLayer({
            event: 'fake_lead',
            element_section: 'ebook',
            referrer: document.referrer
          });
          return;
        }
        const validationResult = validate.validateAll(formEbook);
        if (validationResult.length || formEbook.submitted) {
          if (validationResult.length) {
            notificationHandler.setValidateError(validationResult, button);
          }
          return;
        }
        const buttonInitText = button.querySelector('span.default')?.innerText?.trim() || 'E-Book anfordern';

        button.querySelector('span.default').innerHTML = prepareText;
        const contactDetails = serializeForm(formEbook);
        contactDetails.landing_page_language = language;
        contactDetails.document_name = type;
        contactDetails.insurance_group = pageSettings.insuranceGroup;
        const payload = { contact_details: contactDetails };

        formEbook.submitted = true;

        await attachTrackingPayload(payload);

        postToLeadWithCaptcha('/ebook', payload, {
          captcha: captchaController,
          requireCaptcha: requireCaptchaOnSubmit
        })
          .then(async data => {
            if (data instanceof Error) {
              throw data;
            }
            Object.values(alerts).forEach(alert => {
              slideUp(alert);
            });
            paperPlaneAnimation(button);
            setTimeout(() => {
              paperPlaneAnimationDone(button);
              notificationHandler.setAriaMessage(en ? 'Email successfully sent' : 'E-Mail erfolgreich gesendet', [], button, true);
            }, 3500);
            for (const input of inputs) {
              input.disabled = true;
            }
            //New GA4 Tracking
            pushToDataLayer({
              event: 'email_lead',
              element_section: 'ebook-block',
              element_detail: contactDetails.lead_source,
              link_text: buttonInitText.split('\n')[0],
              doi_status: data.consent_confirmed ? 'validated' : 'pending',
              leadsUserData: {
                email_address: payload.contact_details.email,
                address: {
                  first_name: payload.contact_details.first_name,
                  last_name: payload.contact_details.last_name
                }
              },
              ...getEmailLeadDimenions({})
            });
          })

          //Needs Errorhandling
          .catch(error => {
            if (error.message.includes('must be an email')) {
              notificationHandler.setAriaMessage(alerts.email.textContent, [emailInput], button);
              slideDown(alerts.email);
              button.style.setProperty('--plane-color', 'var(--sec-dark-60)');
              button.disabled = true;
              formEbook.submitted = false;
              button.querySelector('span.default').innerHTML = en ? 'Try again' : 'Erneut versuchen';
              emailInvalid = true;
              emailInput.focus();
            } else {
              notificationHandler.setAriaMessage(alerts.default.textContent, [], button, true);
              button.style.backgroundColor = 'var(--danger)';
              button.disabled = true;
              button.innerText = en ? 'Error' : 'Fehler';
              slideDown(alerts.default);
            }
          });
      });
    });
  }
});
